import { createContext } from 'react';
// Create context with default values
export const AuthContext = createContext(null);
//# sourceMappingURL=AuthContext.js.map